export default __webpack_public_path__ + "static/media/privacy_proteced.ddf6bcc6.svg";